module.exports = __webpack_public_path__ + "static/media/vorxis-3.c34e9011.jpg";